import { useParams, usePathname } from 'next/navigation';

const useLanguageSwitcher = () => {
  const { locale } = useParams();
  const pathname = usePathname();

  const onValueChange = code => {
    const [, ...restWithoutLocale] = pathname.split('/').filter(Boolean);
    const href = `/${code}/${restWithoutLocale.join('/')}`;

    if (locale === code) return;

    window.location.pathname = href;
  };

  return { locale, onValueChange };
};

export { useLanguageSwitcher };
